import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';

const SelectForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      {/* <FormField
        controlId="selectFormDataType"
        label="type"
        name="@data-type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        defaultValue="dataframe"
        readOnly
        error={errors["@data-type"]?.message}
        disabled
      /> */}
      <FormField
        controlId="selectFormAction"
        label="action"
        name="action"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        defaultValue="select"
        readOnly
        disabled
        error={errors.action?.message}
      />
      <FormField
        controlId="selectFormDataFrame"
        label="data-frame"
        name="data-frame"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        required
        error={errors['data-frame']?.message}
      />
      <FormField
        controlId="selectFormQuery"
        label="query"
        name="query"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SPARKQL}
        rows={10}
        required
        error={errors.query?.message}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default SelectForm;
